import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { PageContentBox, AppPageContentWrapper } from "@duosoftbg/nacid-components";
import ARUniEntryRequestNew from "../../../../components/registers/request/arUni/ARUniEntryRequestNew";

const ARUniEntryRequestNewPage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper centerTitle title={t("t.arUniEntryRequest.new")}>
      <AppPageContentWrapper>
        <PageContentBox>
          <ARUniEntryRequestNew />
        </PageContentBox>
      </AppPageContentWrapper>
    </PageWrapper>
  );
};
export default ARUniEntryRequestNewPage;
